import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'

export default function DashboardDocumentsHeader() {
  const navigate = useNavigate()
  const [canDownloadUF, setCanDownloadUF] = useState(true)
  const [downloadingPDF, setDownloadingPDF] = useState(false)

  useEffect(() => {
    const handleDownloadUF = async () => {
      try {
        const newUrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerDocuments.taxDocument2021UF)}`, {
          headers: {
            'Authorization': customerData.accessToken
          }
        })
        const newUrlData = await newUrlResponse.json()
        if (newUrlData.response.error) {
          if (newUrlData.response.error === 'Failed To Authenticate Token.') {
            const refreshedToken = await refreshAccessToken()
            refreshedToken && refreshedToken.length > 0 ? await handleDownloadUF() : navigate('/', { state: { expired: true } })
          } else
            console.error(newUrlData.response.error)
        } else {
          const downloadResponse = await fetch(newUrlData.response.s3Url)
          if (!downloadResponse.ok)
            setCanDownloadUF(false)
        }
      } catch (error) {
        //setCanDownloadUF(false)
      }
    }

    if (customerData.customerDocuments.taxDocument2021UF)
      handleDownloadUF()
    else
      setCanDownloadUF(false)
  }, [])

  const handleDownloadPDF = async (pdfURL) => {
    setDownloadingPDF(true)

    const addForm8888Response = await fetch(`${apiURL}/api/addForms?customerId=${customerData.customerLeadData.leadContact.contactId}&linkURL=${pdfURL}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const blob = await addForm8888Response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url;
    a.download = customerData.customerDocuments.taxDocument2021.split('/').pop()
    document.body.appendChild(a)
    a.click()
    a.remove()

    setDownloadingPDF(false)
  }

  return (
    <div className='shadow-md p-6 rounded-xl lg:w-full w-11/12 h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
      <p className='font-bold text-3xl text-center mt-4'>Print, Sign & Ship Documents</p>
      {customerData.customerDocuments.taxDocument2020.length > 0 && (
        <>
          <p>Download your 2020 IRS Forms to be Completed, Signed, and Mailed</p>
          <button onClick={() => handleDownloadPDF(customerData.customerDocuments['taxDocument2021'])} className='w-full bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white p-4 rounded-md shadow-full'>Download 2020 Tax Documents</button>
        </>
      )}
      {customerData.customerDocuments.taxDocument2021.length > 0 && (
        <div className='flex flex-col items-center gap-4 mt-4'>
          <button 
            onClick={() => canDownloadUF ? navigate('/downloadDocument') : handleDownloadPDF(customerData.customerDocuments['taxDocument2021'])}
            className='w-11/12 p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-lg text-3xl font-bold shadow-md'>
              <div className='flex flex-col items-center gap-2'>
                <p>Download Now</p>
                <p className='text-lg'>Click Here</p>
              </div>
          </button>
          <p className='p-2 rounded-lg text-3xl font-bold bg-red-500'>URGENT:</p>
          <p className='font-bold text-2xl'>Send ASAP for Refund in 5-7 Days</p>
          <p className='text-lg'>Carefully Read Instructions</p>
        </div>
      )}
      {downloadingPDF && (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
          <p>Downloading PDF...</p>
        </div>
      )}
    </div>
  )
}